import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { LIKUT_WITHOUT_AZMANA } from '../../../store/actions/actionsTypes'

/**
 * Centralizes the sidebar navigation state.
 *
 * Previously second.jsx held 11 separate boolean useState's — one per
 * module that has a dropdown — plus two long ternary chains mapping
 * `moduleNum → setter`. This hook collapses that to a single map and
 * a stable API.
 *
 * Behaviour preserved 1:1: each module's dropdown is independent, so
 * multiple dropdowns can be open simultaneously (not accordion).
 */
export const useNavMenu = () => {
  const [openMap, setOpenMap] = useState<Record<number, boolean>>({})
  const dispatch = useDispatch()

  const isOpen = useCallback(
    (moduleId: number) => !!openMap[moduleId],
    [openMap],
  )

  const toggle = useCallback((moduleId: number) => {
    setOpenMap((prev) => ({ ...prev, [moduleId]: !prev[moduleId] }))
  }, [])

  /**
   * Side-effect dispatched when picking a sub-module:
   *   moduleNum === 4 (likut) + Sub_ModuleID === 2 → "likut bli azmana"
   * dispatches LIKUT_WITHOUT_AZMANA so the next route knows to start
   * a fresh likut without an attached order. Other sub-module clicks
   * just navigate via <Link>.
   */
  const handleSubItemSideEffect = useCallback(
    (moduleNum: number, subModuleId: number) => {
      if (moduleNum === 4 && subModuleId === 2) {
        dispatch({ type: LIKUT_WITHOUT_AZMANA })
      }
    },
    [dispatch],
  )

  return { isOpen, toggle, handleSubItemSideEffect }
}

export default useNavMenu
